"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const server_1 = require("react-dom/server");
const styles_1 = require("@material-ui/core/styles");
const EarthSVG_1 = __importDefault(require("./EarthSVG"));
const earthSvgString = encodeURIComponent(server_1.renderToString(EarthSVG_1.default({})));
exports.default = styles_1.makeStyles(() => {
    return {
        container: {
            position: 'relative',
            width: '200px',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            zIndex: 0,
        },
        earth: {
            position: 'relative',
            width: '100%',
            height: '100%',
            backgroundImage: `url("data:image/svg+xml,${earthSvgString}")`,
            backgroundSize: 'cover',
            borderRadius: '50%',
            boxShadow: 'inset -20px 0 rgba(0,0,0,0.1)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: '0.5s',
            animation: '$rotation 10s linear infinite',
            zIndex: -9999,
        },
        airplane: {
            position: 'absolute',
            zIndex: -9997,
            transition: '0.5s',
            pointerEvents: 'none',
            animation: '$flying 2s ease-in-out infinite alternate',
            marginTop: '25%',
            width: '100%',
            height: '100%',
        },
        circle: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            transform: 'rotate(30deg)',
            zIndex: -9998,
        },
        '@keyframes rotation': {
            '0%': {
                backgroundPosition: '0 0',
            },
            '100%': {
                backgroundPosition: '-200% 0',
            },
        },
        '@keyframes flying': {
            '0%': {
                transform: 'scale(0.5) rotate(30deg)',
            },
            '100%': {
                transform: 'scale(0.7) rotate(30deg)',
            },
        },
    };
});
